import { Clickable, ClickableProps } from "../shared/clickable/clickable.tsx";
import { Title } from "../shared/title/title.tsx";
import './discography.css';

function Discography() {
    const isMobile: boolean = window.screen.width < 600;


    const discography: ClickableProps[] = [
        {
            img: process.env.PUBLIC_URL + '/assets/ep_cover.jpg',
            url: 'https://holdmetightband.bandcamp.com/album/hold-me-tight',
            description: 'HOLD ME TIGHT\nEP (2023)',
            size: isMobile ? "sm": "lg"
        },
        {
            img: process.env.PUBLIC_URL + '/assets/LOGO_BANNER_2025.png',
            url: 'https://holdmetightband.bandcamp.com/track/weave',
            description: 'WEAVE\nSINGLE (2025)',
            size: isMobile ? "sm": "lg"
        },
        {
            img: process.env.PUBLIC_URL + '/assets/HOLD_ME_TIGHT-3kx3k.jpg',
            url: 'https://holdmetightband.bandcamp.com/track/no-turning-back',
            description: 'NO TURNING BACK\nSINGLE (2026)',
            size: isMobile ? "sm": "lg"
        },
        {
            img: process.env.PUBLIC_URL + '/assets/HOLD_ME_TIGHT-3kx3k.jpg',
            url: 'https://holdmetightband.bandcamp.com/track/silence-before-rebirth-feat-desolated',
            description: 'SILENCE BEFORE REBIRTH\nSINGLE (2026)',
            size: isMobile ? "sm": "lg"
        }
    ]

    return <div id='discography' className="animated">
        <Title value="Discography" />
        <div id='discography-container'>
            {discography.map((el: ClickableProps) => <Clickable key={el.url} {...el} />)}
        </div>
    </div>
}

export { Discography }